// import Vue from 'vue'
// import linkify from 'linkifyjs/string'

// import timeagoFilter from './timeago'
// import speedToColorsFilter from './speedToColors'
import moment from './moment'

// const linkifyFilter = Vue.filter('linkify', src => linkify(src, { defaultProtocol: 'https', nl2br: true }))

export default () => {
  return {
    // linkify: linkifyFilter,
    moment
    // speedToColors: speedToColorsFilter
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js